export default {
  LOCAL_STORAGE_KEYS: {
    stakewise: 'stakewise-store'
  },
  VERSION: {
    stakewise: '0.0.6'
  }
};
